import script from "./PagesCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./PagesCarousel.vue?vue&type=script&setup=true&lang=js"

import "./PagesCarousel.vue?vue&type=style&index=0&id=527526a0&lang=sass&scoped=true"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-527526a0"]])

export default __exports__